<template>
  <div class="page">
    <div class="header">
      <button class="back-btn" @click="$router.back()">返回</button>
      <h2 class="header-title">我创建的小组</h2>
    </div>
    <!-- 独立滚动容器 -->
    <div class="scroll-wrap">
      <div class="content">
        <div v-if="groupList.length === 0" class="empty-tip">
          <div class="empty-icon">📭</div>
          <!-- 文字改为按钮，点击返回，移除原来的去创建小组按钮 -->
          <button class="empty-back-btn" @click="$router.back()">你还没有创建任何小组</button>
        </div>
        <div v-else class="group-card-wrap">
          <div class="group-item" v-for="item in groupList" :key="item.groupId">
            <div class="group-info">
              <!-- 1. 小组名称作为绝对主标题放最前面 -->
              <h3 class="group-name">{{ item.groupName || '未命名小组' }}</h3>
              <!-- 2. 主题类型跟在后面 -->
              <span class="type-tag">{{ getGroupTypeName(item.groupType, item.otherSubType) }}</span>
              <!-- 3. 成员数量放最后 -->
              <span class="group-tag">成员 {{item.memberList.length}}/{{item.maxMember}}</span>
            </div>
            <button class="manage-btn" @click="$router.push({path:'/groupManage', query:{id:item.groupId}})">管理</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGroupList , getMyGroupList} from '@/api/footprint.js'
export default {
  name: 'GroupCreatedList',
  data() {
    return {
      groupList: []
    }
  },
  mounted() {
    this.loadCreatedGroups()
  },
  methods: {
    async loadCreatedGroups() {
      const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}")
      const phone = currentUser.phone
      if(!phone) return
      const allGroups = await getMyGroupList()
      // 保留原版筛选逻辑不动
      this.groupList = allGroups.filter(g => g.masterAccount === phone)
    },
    getGroupTypeName(type, subType) {
      const map = {
        lover:"恋人伴侣",
        child:"亲子眷幼",
        parent:"孝亲伴老",
        other: {
          colleague:"同事",
          friend:"朋友",
          relative:"亲戚",
          classmate:"同学"
        }
      }
      if(type === 'other'){
        return map.other[subType] || "其他"
      }
      return map[type] || "其他"
    }
  }
};

</script>

<style scoped>
/* ============================================================
   1. 页面骨架
   ============================================================ */
.page {
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 500px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.55);
}

/* ============================================================
   2. Header：完美复刻高光玻璃导航
   ============================================================ */
.header {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  height: clamp(48px, 7vh, 68px); 
  display: flex;
  align-items: center;
  padding: 0 clamp(16px, 3vw, 24px); 
  box-sizing: border-box;
  
  /* 👇 图片作为背景垫在最下面，透明度降到 0.3，不要抢戏 */
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 400px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.4); /* 底色变半透明 */
  
  /* 👇 顶层再盖一层白色的高光渐变 */
  background-blend-mode: overlay; 
  
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.back-btn {
  border-radius: 6px; 
  height: clamp(24px, 3.2vh, 28px);
  padding: 0 clamp(8px, 1.2vw, 14px); 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  font-size: clamp(11px, 1.1vw, 14px);
  line-height: 1.2; 
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}
.back-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.15);
}

.header-title {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  color: #2c3e50 !important; 
  font-size: clamp(16px, 2.2vw, 22px) !important; 
  font-weight: 900 !important; 
  letter-spacing: 3px !important; 
  white-space: nowrap !important;
  pointer-events: none !important;
  line-height: 1.2 !important;
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(255, 255, 255, 0.6),
    0 1px 0px rgba(255, 255, 255, 1) !important;
}

/* ============================================================
   3. 滚动区域与内容
   ============================================================ */
.scroll-wrap {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.content {
  padding: clamp(12px, 2vw, 20px);
  max-width: 1200px;
  margin: 0 auto;
}

.empty-tip {
  margin-top: clamp(40px, 10vh, 100px);
  text-align: center;
  color: #555;
}
.empty-icon {
  font-size: clamp(30px, 5vw, 50px);
  margin-bottom: 12px;
}

/* 空状态返回按钮 */
.empty-back-btn {
  padding: clamp(4px, 1vw, 8px) clamp(16px, 3vw, 24px);
  border-radius: 8px;
  font-size: clamp(13px, 1.3vw, 16px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #fff;
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.empty-back-btn:hover {
  transform: translateY(-1px);
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.95);
}

/* ============================================================
   4. 列表网格
   ============================================================ */
.group-card-wrap {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 默认 2 列 */
  gap: clamp(12px, 1.8vw, 20px);
}

/* 小屏幕切为 1 列 */
@media (max-width: 768px) {
  .group-card-wrap {
    grid-template-columns: 1fr;
  }
}

/* ============================================================
   5. 小组卡片（高光琉璃）
   ============================================================ */
.group-item {
  position: relative;
  background: rgba(255, 255, 255, 0.45); 
  backdrop-filter: blur(12px); 
  -webkit-backdrop-filter: blur(12px); 
  border: 1px solid rgba(255, 255, 255, 0.7); 
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.1), 
    0 2px 6px rgba(0, 0, 0, 0.05),
    inset 0 1px 2px rgba(255, 255, 255, 0.8);
  
  border-radius: 12px;
  padding: clamp(12px, 1.5vw, 16px) clamp(14px, 1.8vw, 20px) clamp(12px, 1.5vw, 16px) clamp(20px, 2vw, 28px); 
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.25s ease;
  overflow: hidden;
}

/* 左侧粉色胶囊色条自适应 */
.group-item::before {
  content: '';
  position: absolute;
  left: clamp(8px, 1vw, 12px);
  top: clamp(12px, 1.5vh, 16px);
  bottom: clamp(12px, 1.5vh, 16px);
  width: 4px;
  background: #FAB8CF;
  border-radius: 4px;
}

.group-item:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 12px 32px rgba(0, 0, 0, 0.15), 
    inset 0 1px 3px rgba(255, 255, 255, 0.9);
}

.group-info {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1vw, 14px);
  flex: 1;
  min-width: 0; /* 核心：允许内容溢出隐藏 */
}

/* 👇 取消死板的 max-width，使用 min-width: 0 配合 flex 自适应 */
.group-name {
  font-size: clamp(14px, 1.4vw, 17px);
  font-weight: 800;
  margin: 0;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.type-tag {
  color: #52C41A;
  font-size: clamp(11px, 1vw, 13px);
  white-space: nowrap;
  flex-shrink: 0;
}

.group-tag {
  color: #409eff;
  font-size: clamp(11px, 1vw, 13px);
  white-space: nowrap;
  flex-shrink: 0;
}

/* 管理按钮：完美复刻“导出足迹数据”的翠绿琉璃 */
.manage-btn {
  padding: clamp(4px, 0.8vh, 6px) clamp(10px, 1.5vw, 16px);
  border-radius: 6px;
  font-size: clamp(12px, 1.2vw, 14px);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: clamp(8px, 1vw, 12px);
  transition: all 0.2s ease;
  color: #fff;
  
  /* 👇 绿色渐变 + 白色顶部高光 */
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), 
              rgba(82, 196, 26, 0.85);
  
  /* 👇 清晰的边缘：加粗白边框 + 内部底部暗角，防止糊底 */
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 
    0 4px 12px rgba(82, 196, 26, 0.25),
    inset 0 1px 2px rgba(255, 255, 255, 0.6),
    inset 0 -2px 4px rgba(0, 0, 0, 0.15);
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}

.manage-btn:hover {
  transform: translateY(-1px);
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), 
              rgba(82, 196, 26, 0.95);
  box-shadow: 
    0 6px 16px rgba(82, 196, 26, 0.35),
    inset 0 1px 3px rgba(255, 255, 255, 0.7);
}

.manage-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.2);
}
</style>